import { render, staticRenderFns } from "./customerTree.vue?vue&type=template&id=84be505a&scoped=true&"
import script from "./customerTree.vue?vue&type=script&lang=js&"
export * from "./customerTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84be505a",
  null
  
)

export default component.exports